<template>
  <v-footer
    id="pages-core-footer"
    absolute
    color="transparent"
    dark
  >
    <v-container>
      <v-row
        align="center"
        no-gutters
      >
        <v-col
          v-for="(link, i) in links"
          :key="i"
          class="text-center"
          cols="6"
          md="auto"
        >
          <a
            :href="link.href"
            class="mr-0"
            rel="noopener"
            target="_blank"
            v-text="link.text"
          />
        </v-col>

        <v-spacer class="hidden-sm-and-down" />

        <v-col
          cols="12"
          md="auto"
        >
          <div class="text-body-1 font-weight-light pt-6 pt-md-0 text-center">
            &copy; {{ ano }},
            Magistech Sistemas  (v {{ versao }}).
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
  import {
    mapState,
  } from 'vuex'
  export default {
    name: 'PagesCoreFooter',

    data: () => ({
      links: [],
      corPrimaria: localStorage.corPrimaria,
      ano: (new Date()).getFullYear(),

    }),

    computed: {
      ...mapState(['versao']),
    },
    mounted () {
      const dataAtual = new Date()

      // Obtém o ano atual
      this.ano = dataAtual.getFullYear()
    },
  }
</script>

<style lang="sass">
  #pages-core-footer
    a
      color: #FFFFFF
      font-size: .825rem
      font-weight: 500
      text-decoration: none
      text-transform: uppercase
</style>
